if (!customElements.get('check-balance')) {
  class CheckGiftCardBalanceForm extends HTMLElement {

    constructor() {
      super();
      this.balanceForm = this.querySelector('[data-gift-card-balance-form]');
      this.balanceEntry = this.querySelector('[data-gift-card-balance-entry]');
      this.giftCardError = this.querySelector('[data-gift-card-error]');
      this.captchaError = this.querySelector('[data-givex-captcha-error]');
      this.checkCaptchaError();
      this.createCaptcha();
      this.balanceForm.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    checkCaptchaError() {
      const queryError = getUrlParameter('error');
      if (queryError === 'captcha') this.captchaError.style.display = 'block';
    }

    createCaptcha() {
      const container = this;
      fetch('https://puravida.gadget.app/givex-captcha')
        .then((res) => res.json())
        .then(({ hash, svg, timestamp }) => {
          container.balanceForm.querySelector('input[name="captcha_hash').value = hash;
          container.balanceForm.querySelector('input[name="captcha_timestamp').value = timestamp;
          container.balanceForm.querySelector('[data-givex-captcha-svg]').innerHTML = svg;
        });
    }

    onFormSubmit(event) {
      event.preventDefault();
      const { target } = event;
      const formElements = target.elements;
      const code = formElements.gift_card_code.value;
      const userCaptcha = formElements.captcha.value;
      const timestamp = formElements.captcha_timestamp.value;
      const hash = formElements.captcha_hash.value;

      const data = {
        captcha: userCaptcha.toLowerCase(),
        timestamp,
        hash,
      };

      fetch('https://puravida.gadget.app/givex-validate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          if (!res.ok) {
            throw Error('CAPTCHA Validation Failed');
          }
          return res.json();
        })
        .then((json) => {
          this.checkGiveXBalance(code);
        })
        .catch((error) => {
          console.error('Error:', error);
          window.location.href = `${window.location.pathname}?error=captcha`;
        });
    }

    checkGiveXBalance(code) {
      const container = this;
      container.captchaError.style.display = 'none';
      if (code.startsWith('608558') || code.startsWith('603571')) {
        jQuery.ajax({
          url: `/apps/api/v1/balance?gift_card_code=${code}`,
          type: 'GET',
        })
          .done(function (data, textStatus) {
            const { balance } = data;
            container.giftCardError.innerHTML = '';
            container.giftCardError.style.display = 'none';
            container.balanceEntry.innerHTML = `
              <div>Remaining balance for gift card <span class="code">${code}</span>:<span class="money">$${Number(balance).toFixed(
              2
            )}</span></div>
            `;
            container.balanceForm.reset();
          })
          .fail(function (data) {
            container.balanceEntry.innerHTML = '';
            container.giftCardError.innerHTML = `
              <div>Gift card <span class="code">${code}</span> not found.</div>
            `;
            container.giftCardError.style.display = 'block';
          });
      } else {
        container.giftCardError.innerHTML = `<div><span class="code">${code}</span> is not a valid gift card code.</div>`;
        container.giftCardError.style.display = 'block';
      }
    }
  }
  customElements.define('check-balance', CheckGiftCardBalanceForm);
}